module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 14
// module chunks = 0